/* sdx-home-hero — vanilla, section-scoped slider with autoplay/IO/hover/reduced-motion. */
(function () {
  'use strict';

  var MQ_REDUCED = '(prefers-reduced-motion: reduce)';

  function init(root) {
    if (!root || root.__sdxHeroInit) return;
    root.__sdxHeroInit = true;

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-sdx-hero-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-sdx-hero-dot]'));
    var prev = root.querySelector('[data-sdx-hero-prev]');
    var next = root.querySelector('[data-sdx-hero-next]');

    if (slides.length <= 1) {
      // Tek slide — autoplay/dots/arrows gerekmez, ama video varsa muted+autoplay halen çalışır.
      bootVideoForActive(slides[0]);
      return;
    }

    var autoplay = root.dataset.autoplay === 'true';
    var delay = parseInt(root.dataset.autoplayDelay || '5500', 10);
    var pauseOnHover = root.dataset.pauseOnHover === 'true';
    var reduced = window.matchMedia && window.matchMedia(MQ_REDUCED).matches;

    var index = 0;
    var timer = null;
    var visible = true;
    var hovered = false;

    function setActive(target, dir) {
      if (target === index) return;
      var cur = slides[index];
      var nxt = slides[target];
      if (!cur || !nxt) return;

      // Slide-mode: prev marker for slide-out direction
      slides.forEach(function (s) { s.classList.remove('is-prev'); });
      if (root.dataset.transition === 'slide' && dir === -1) {
        cur.classList.add('is-prev');
      }

      cur.classList.remove('is-active');
      cur.setAttribute('aria-hidden', 'true');
      pauseVideoIn(cur);

      nxt.classList.add('is-active');
      nxt.setAttribute('aria-hidden', 'false');
      bootVideoForActive(nxt);

      if (dots[index]) {
        dots[index].classList.remove('is-active');
        dots[index].setAttribute('aria-current', 'false');
      }
      if (dots[target]) {
        dots[target].classList.add('is-active');
        dots[target].setAttribute('aria-current', 'true');
      }

      index = target;
    }

    function go(dir) {
      var t = (index + dir + slides.length) % slides.length;
      setActive(t, dir);
    }
    function show(i) {
      var dir = i > index ? 1 : -1;
      setActive((i + slides.length) % slides.length, dir);
    }

    function start() {
      stop();
      if (!autoplay || reduced) return;
      if (!visible) return;
      if (hovered && pauseOnHover) return;
      timer = window.setInterval(function () { go(1); }, delay);
    }
    function stop() {
      if (timer) { window.clearInterval(timer); timer = null; }
    }

    if (prev) prev.addEventListener('click', function () { go(-1); start(); });
    if (next) next.addEventListener('click', function () { go(1);  start(); });

    dots.forEach(function (d, i) {
      d.addEventListener('click', function () { show(i); start(); });
    });

    if (pauseOnHover) {
      root.addEventListener('mouseenter', function () { hovered = true; stop(); });
      root.addEventListener('mouseleave', function () { hovered = false; start(); });
      root.addEventListener('focusin',    function () { hovered = true; stop(); });
      root.addEventListener('focusout',   function () { hovered = false; start(); });
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          visible = entry.isIntersecting;
          if (visible) start(); else stop();
        });
      }, { threshold: 0.1 });
      io.observe(root);
      root.__sdxHeroIO = io;
    }

    if (window.matchMedia) {
      var mm = window.matchMedia(MQ_REDUCED);
      var onChange = function (e) { reduced = e.matches; if (reduced) stop(); else start(); };
      if (mm.addEventListener) mm.addEventListener('change', onChange);
      else if (mm.addListener) mm.addListener(onChange);
    }

    // Touch swipe (mobile)
    var startX = null;
    root.addEventListener('touchstart', function (e) {
      if (e.touches && e.touches[0]) startX = e.touches[0].clientX;
    }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (startX == null) return;
      var endX = (e.changedTouches && e.changedTouches[0]) ? e.changedTouches[0].clientX : startX;
      var dx = endX - startX;
      startX = null;
      if (Math.abs(dx) < 40) return;
      if (dx < 0) go(1); else go(-1);
      start();
    }, { passive: true });

    // Keyboard
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft')  { go(-1); start(); e.preventDefault(); }
      if (e.key === 'ArrowRight') { go(1);  start(); e.preventDefault(); }
    });
    root.tabIndex = 0;

    bootVideoForActive(slides[0]);
    start();

    root.__sdxHeroStop = stop;
    root.__sdxHeroStart = start;
    root.__sdxHeroShow = show;
  }

  function bootVideoForActive(slide) {
    if (!slide) return;
    var v = slide.querySelector('[data-sdx-hero-video]');
    if (!v) return;
    // Sadece video DOM'da hazır + muted'sa autoplay'e izin verilir (browser policy)
    if (v.muted) {
      var p = v.play();
      if (p && typeof p.catch === 'function') p.catch(function () { /* autoplay engellendi, silent */ });
    }
  }

  function pauseVideoIn(slide) {
    if (!slide) return;
    var v = slide.querySelector('[data-sdx-hero-video]');
    if (!v) return;
    try { v.pause(); } catch (e) {}
  }

  function destroy(root) {
    if (!root || !root.__sdxHeroInit) return;
    if (root.__sdxHeroStop) root.__sdxHeroStop();
    if (root.__sdxHeroIO && root.__sdxHeroIO.disconnect) root.__sdxHeroIO.disconnect();
    root.__sdxHeroInit = false;
  }

  function bootAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-sdx-hero]');
    Array.prototype.forEach.call(roots, function (r) { init(r); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bootAll(document); });
  } else {
    bootAll(document);
  }

  document.addEventListener('shopify:section:load', function (e) { bootAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var r = e.target && e.target.querySelector && e.target.querySelector('[data-sdx-hero]');
    if (r) destroy(r);
  });
  document.addEventListener('shopify:block:select', function (e) {
    var root = e.target && e.target.closest && e.target.closest('[data-sdx-hero]');
    if (!root) return;
    var slide = e.target.closest('[data-sdx-hero-slide]');
    if (!slide) return;
    var idx = parseInt(slide.getAttribute('data-index') || '0', 10);
    if (root.__sdxHeroStop) root.__sdxHeroStop();
    if (root.__sdxHeroShow) root.__sdxHeroShow(idx);
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    var root = e.target && e.target.closest && e.target.closest('[data-sdx-hero]');
    if (root && root.__sdxHeroStart) root.__sdxHeroStart();
  });
})();

/* Mobile video poster swap — uses data-poster-mobile when viewport <=768px */
(function () {
  var MQ = window.matchMedia('(max-width: 768px)');
  function applyPosters() {
    var videos = document.querySelectorAll('[data-sdx-hero-video][data-poster-mobile]');
    for (var i = 0; i < videos.length; i++) {
      var v = videos[i];
      var mob = v.getAttribute('data-poster-mobile');
      if (!mob) continue;
      if (!v.dataset.posterDesktop) {
        v.dataset.posterDesktop = v.getAttribute('poster') || '';
      }
      var target = MQ.matches ? mob : v.dataset.posterDesktop;
      if (v.getAttribute('poster') !== target) {
        v.setAttribute('poster', target);
      }
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyPosters, { once: true });
  } else {
    applyPosters();
  }
  if (MQ.addEventListener) MQ.addEventListener('change', applyPosters);
  else if (MQ.addListener) MQ.addListener(applyPosters);
})();
